<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W93wjo/tc-custom/9781788630757.jpg?1705322259537" alt="This image is the cover for the book Shoddy Prince, The Prince Family Sagas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shoddy Prince, The Prince Family Sagas
      </h1>
      <p class="bookDescription body article font2">
        <b>From an author praised for her “genuinely perceptive portrayals of human relationships,” a historical romantic saga set in the years prior to WWI (<i>Irish Independent</i>).</b><br/><br/>Bright Maguire—poor, beautiful and kind—is the youngest member of a large Irish clan. Nat Prince is the illegitimate son of a prostitute, growing up on poverty-stricken streets.<br/><br/> When Bright brings Nat into the bosom of her loving family, things look better for the young man. But Nat will risk anything to make his fortune. Ever the opportunist, his colorful adventures take him across the world, while Bright struggles to survive the suffering he has left behind. Although their love is destined never to die, it seems there is a conspiracy to keep Nat and Bright apart . . .<br/><br/> Rich in atmosphere and full of highly memorable characters, <i>Shoddy Prince</i> is a heart-warming saga of love, ruthlessness and courage, perfect for fans of Anna Jacobs, Rosie Goodwin and Kitty Neale.<br/><br/> Praise for the writing of Sheelagh Kelly:<br/>  <br/> “The tough, sparky characters of Catherine Cookson, and the same sharp sense of destiny, place and time.” —Reay Tannahill, author of <i>Fatal Majesty</i> and <i>Sex in History</i><br/>  <br/> “Sheelagh Kelly surely can write.” —<i>Sunderland Echo</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sheelagh Kelly
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4502a46c